import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, PRIMARY_OUTLET, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Store } from '@ngxs/store';

const APP_BASE_TITLE = 'InsightDX';

@Injectable()
export class IdxTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly store = inject(Store);

  public override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);

    if (!pageTitle) {
      return;
    }

    this.title.setTitle(`${APP_BASE_TITLE} - ${pageTitle}`);
  }

  public override buildTitle(snapshot: RouterStateSnapshot): string | undefined {
    const deepestRoute = this.getDeepestPrimaryRoute(snapshot.root);
    const routeTitle = deepestRoute.data['title'] as string | undefined;

    return routeTitle ? routeTitle : undefined;
  }

  private getDeepestPrimaryRoute(snapshot: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    let current = snapshot;

    while (current.firstChild) {
      const primaryChild = current.children.find(child => child.outlet === PRIMARY_OUTLET);

      if (!primaryChild) {
        break;
      }

      current = primaryChild;
    }

    return current;
  }
}
